/* Deviceli wholesale: show "Available now" or "On request" per model, never quantities.
   Exact quantities, prices and IMEIs go out in the private stock list after a request. */
(function(){
  var S = window.DV_STOCK;
  if (!S || typeof P === 'undefined' || typeof pageWholesale !== 'function') return;
  function norm(s){ return String(s).toLowerCase().replace(/generation/g, 'gen').replace(/[^a-z0-9]/g, ''); }
  var byN = {};
  Object.keys(S).forEach(function(k){ byN[norm(k)] = S[k]; });
  function live(p){ var r = byN[norm(p.name)]; return !!(r && (r.A || r.B || r.C)); }
  function catOf(n){ return /iPad/.test(n) ? 'ipad' : /iPhone/.test(n) ? 'iphone' : /Galaxy|Pixel|OnePlus/.test(n) ? 'android' : /MacBook|iMac|Mac mini/.test(n) ? 'mac' : /Watch/.test(n) ? 'watch' : 'iphone'; }

  /* in-stock models from the shop that the wholesale list does not have yet */
  Object.keys(S).forEach(function(k){
    var s = S[k];
    if (!(s.A || s.B || s.C)) return;
    if (P.some(function(p){ return norm(p.name) === norm(k); })) return;
    var id = 'sh_' + norm(k);
    if (typeof IMG !== 'undefined') IMG[id] = s.img || '';
    P.push({id:id, name:k, brand:'', cat:catOf(k), art:id, price:0, msrp:0, storage:((s.caps || []).filter(Boolean).length ? s.caps.filter(Boolean) : ['Ask']), colors:[]});
  });
  /* available models first, then the rest in their usual order */
  var base = P.slice();
  P.sort(function(a, b){ return (live(b) - live(a)) || (base.indexOf(a) - base.indexOf(b)); });

  /* any model and grade can be requested; we source what is not on the shelf */
  window.wsStock = function(p){ return {A:99, B:99, C:99, D:(typeof WS_D_CATS !== 'undefined' && WS_D_CATS.indexOf(p.cat) >= 0) ? 99 : 0}; };

  /* the downloadable list names models and availability only */
  window.wsCSV = function(){
    var rows = [['Model','Category','Capacities','Availability']];
    P.forEach(function(p){ rows.push([p.name, ((typeof CATS !== 'undefined' && CATS.find(function(c){ return c.id === p.cat; })) || {}).label || '', (typeof isCapacity === 'function' && isCapacity(p.storage[0])) ? p.storage.join(' / ') : '', live(p) ? 'Available now' : 'On request']); });
    var csv = rows.map(function(r){ return r.map(function(v){ return '"' + String(v).replace(/"/g, '""') + '"'; }).join(','); }).join('\n');
    try {
      var url = URL.createObjectURL(new Blob([csv], {type:'text/csv'}));
      var a = document.createElement('a'); a.href = url; a.download = 'deviceli-wholesale-models.csv'; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function(){ URL.revokeObjectURL(url); }, 1000);
    } catch(e) {}
  };

  var TO_FORM = "document.getElementById('wslot').scrollIntoView({behavior:'smooth',block:'start'})";
  var TO_LIST = "document.getElementById('wsstock').scrollIntoView({behavior:'smooth',block:'start'})";
  function sub(h, a, b){ return h.split(a).join(b); }
  var orig = pageWholesale;
  window.pageWholesale = function(){
    var h = orig();
    var cat = (typeof state !== 'undefined' && state.wscat) || '';
    var list = P.filter(function(p){ return !cat || p.cat === cat; }), i = 0;
    h = h.replace(/<div class="wstot">Ask for stock<\/div>/g, function(){
      var p = list[i++], on = p && live(p);
      return '<div class="wstot"><span class="wsav' + (on ? ' on' : '') + '">' + (on ? 'Available now' : 'On request') + '</span></div>';
    });
    h = h.replace(/<div class="slideacts wsacts">[\s\S]*?<\/div>/, '<div class="slideacts wsacts"><button class="hbtn solid" onclick="' + TO_FORM + '">Request the stock list</button><button class="hlink" onclick="' + TO_LIST + '">See the models</button></div>');
    h = sub(h, '<h2 class="wsh2">Stock list</h2><button class="wscsv" data-wscsv>Download CSV</button>', '<h2 class="wsh2">Models we supply</h2><button class="wscsv" data-wscsv>Download model list</button>');
    h = sub(h, '<p class="wssub">Pick a grade, then the quantity. Prices are per unit and quoted by lot.</p>', '<p class="wssub">Availability changes every day. Pick the models, grades and quantities you want, and we send the full stock list with exact quantities, per-unit prices and IMEIs.</p>');
    h = sub(h, '<span>Model</span><span>Stock</span>', '<span>Model</span><span>Availability</span>');
    h = sub(h, 'Pick models and grades from the stock list.', 'Pick models and grades from the list below.');
    h = sub(h, '<b>Get your quote</b><span>A per-unit price in CAD, with the IMEI list and a test report for every unit.</span>', '<b>Get the stock list</b><span>Exact quantities, a per-unit price in CAD, the IMEI list and a test report for every unit.</span>');
    h = sub(h, '<h2 class="wsh2">Request a quote</h2>', '<h2 class="wsh2">Request the stock list</h2>');
    h = sub(h, '>Request a quote</button>', '>Request the stock list</button>');
    h = sub(h, '>Request a quote · ', '>Request the stock list · ');
    h = sub(h, 'A priced quote and the IMEI list follow within one business day.', 'We confirm your business, then send the full stock list with quantities and prices within one business day.');
    h = sub(h, 'Browse the stock list</button>', 'Browse the models</button>');
    h = sub(h, 'Per unit in CAD, quoted by lot. HST added for Canadian buyers', 'Per unit in CAD, quoted by lot, with better pricing at 20+ and 50+ units. HST added for Canadian buyers');
    return h;
  };
  try { if (typeof route === 'function') route(); } catch (e) {}
})();
